module.exports = __webpack_public_path__ + "img/031-candy-1.e28659fd.png";